import Full from "Container/Full";

// IMPORT ROUTES FROM MODULES
var moduleRoutes = {
    path: "/",
    component: Full,
    redirect: "/dashboard",
    children: [],
};

const coreRouterFiles = require.context(
    "Core", // current directory
    true, // subdirectories
    /router\.[a-zA-Z0-9_]+\.js$/ // only .js
);

coreRouterFiles.keys().forEach((filename) => {
    var nextFile = coreRouterFiles(filename).default || coreRouterFiles(filename);
    moduleRoutes["children"].push(...nextFile["children"]);
});

const moduleRouterFiles = require.context(
    "Modules", // current directory
    true, // subdirectories
    /router\.[a-zA-Z0-9_]+\.js$/ // only .js
);

moduleRouterFiles.keys().forEach((filename) => {
    var nextFile = moduleRouterFiles(filename).default || moduleRouterFiles(filename);
    moduleRoutes["children"].push(...nextFile["children"]);
});

export default moduleRoutes;
